import { auditReports } from '@mi-front/api-clients';
import { MrtTable, NullState, QueryView } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { createScheduledRunsColumns } from '../../../components/columns/ScheduledRunsColumns';

interface Props {
  rule: auditReports.AodRule;
}

export function ScheduledRunsContent({ rule }: Props) {
  const { formatMessage } = useIntl();

  const scheduledRunsQuery = auditReports.useGetAodScheduledRunsScheduledRunsForRule(rule.id);

  return (
    <QueryView query={scheduledRunsQuery}>
      {(scheduledRuns: auditReports.ScheduledAodRunDto[]) => {
        if (!scheduledRuns || scheduledRuns.length === 0) {
          return (
            <NullState>
              {formatMessage({
                id: 'audit.aod.rules.view.runs.noFutureRuns',
                defaultMessage: 'No hay ejecuciones programadas para esta regla.',
              })}
            </NullState>
          );
        }

        return (
          <MrtTable<auditReports.ScheduledAodRunDto>
            data={scheduledRuns}
            columns={createScheduledRunsColumns(formatMessage, {
              includeActions: true,
              includeRuleLink: false,
            })}
            enablePagination
            enableFilters
            enableGlobalFilter
            enableSorting
            enableExpandAll={false}
            memoizeColumns={false}
            enableHiding={false}
            enableColumnActions={false}
            globalFilterFn="includesString"
          />
        );
      }}
    </QueryView>
  );
}
